import React, { useEffect } from "react"
import PropTypes from "prop-types"

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad()
  }, [onLoad])

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="531 789 531 863 642 873 642 877 683 886 759 893 796 896 898 887 898 878 838 874 1053 859 1080 858 1259 841 1259 807 1286 807 1286 806 1207 800 1017 784 1028 782 924 774 905 774 747 761 468 786 531 789"
      />
      <polygon
        data-floor="1"
        points="468 786 562.45 777.54 683.99 766.65 747 761 905 774 923.08 774 965.62 777.2 1028 782 1017 784 1055.57 787.25 1088.41 790.01 1132.2 793.7 1186.27 798.25 1238.93 802.42 1287 806 1287 774 1274 771 1277 769 1254 763 1237 763 1013 714 1031 712 924 687 903 689 748 655 466 722 466 786 468 786"
      />
      <polygon
        data-floor="2"
        points="466 722 611.52 687.42 748 655 903 688 924 687 1031 712 1013 714 1161.67 746.52 1237 763 1254 763 1277 769 1274 771 1287 774 1287 740 1269 735 1277 735 1254 725 1242 725 1014 644 1032 640 923 600 903 604 747 549 466 658 466 722"
      />
      <polygon
        data-floor="3"
        points="468.21 657.14 527.63 634.09 747 549 903 604 923 600 1032 640 1014 644 1242 725 1254 725 1277 735 1269.26 735.07 1287 740 1287 711 1270 701 1277 700 1253 687 1241 687 1014 574 1031 569 923 515 905 519 747 442 468 593 468.21 657.14"
      />
      <polygon
        data-floor="4"
        points="468 593 747 442 905 519 923 515 1016.02 561.51 1031 569 1014 574 1241 687 1253 687 1277 700 1270 701 1287 711 1287 679 1269 666 1277 665 1254 649 1241 649 1013 505 1029 498 923 427 904 433 747 336 468 528 468 593"
      />
      <polygon
        data-floor="5"
        points="468 528 747 336 904 432 923 427 1029 498 1013 505 1241 649 1254 649 1277 665 1269 666 1287 679 1287 647 1268 631 1278 630 1254 611 1242 612 1013 435 1029 427 923 343 902 350 747 231 468 464 468 528"
      />
      <polygon
        data-floor="6"
        points="468 464 747 231 902 350 923 343 1029 427 1013 435 1242 612 1254 611 1278 630 1268 631 1287 647 1287 615 1268 597 1277 595 1254 572 1242 573 1013 365 1030 357 923 256 905 264 748 124 469 399 468 464"
      />
      <polygon
        data-floor="7"
        points="469 399 748 124 905 264 923 256 1030 357 1013 365 1242 573 1254 572 1277 595 1268 597 1287 615 1287 602 1278 594 1278 581 1254 558 1243 560 1030 354 1030 329 922 221 904 233 747 84 470 373 469 399"
      />
    </svg>
  )
}

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
}

export default Map
